import { render, staticRenderFns } from "./TextAdd.vue?vue&type=template&id=74584336&"
import script from "./TextAdd.vue?vue&type=script&lang=js&"
export * from "./TextAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports